import React, { FC } from 'react';
import { useResizeContext } from "../../../../providers/ResizeProvider/ResizeProvider";
import { Section } from "../../../../components/Section";
import { FlexBox } from "../../../../../../components/FlexBox";
import { Title } from "../../../../components/Topography/Title";
import { homePageTexts } from "../../const";
import { Paragraph } from "../../../../components/Topography/Paragraph";
import { SectionImageContainer } from "../../../../components/SectionImageContainer";
import image from "../../../../images/SharingScreenImage2.png";

export const ShareScreenshotSection: FC = () => {
    const { isMobile } = useResizeContext();

    return (
        <Section style={{marginTop: 0}}>
            <FlexBox
                justify='space-between'
                align={isMobile ? 'middle' : 'top'}
                style={{ gap: isMobile ? '0' : '80px'}}
                column={isMobile}
            >
                <FlexBox column style={{ padding: isMobile ? 0 : '40px', gap: '40px' }}>
                    <FlexBox column gap='medium'>
                        <Title level={3} size={isMobile ? 'tiny' : 'small'} weight='regular' style={{ textTransform: 'uppercase' }} secondary>
                            {homePageTexts.shareScreenshot.h3}
                        </Title>
                        <Title level={2} size={isMobile ? 'normal' : 'big'} weight='bold' >
                            {homePageTexts.shareScreenshot.h2}
                        </Title>
                    </FlexBox>
                    <Paragraph  size='small' weight='regular'>
                        {homePageTexts.shareScreenshot.p}
                    </Paragraph>
                </FlexBox>
                <SectionImageContainer>
                    <img src={image} alt=""/>
                </SectionImageContainer>
            </FlexBox>
        </Section>
    );
}